<ngx-select id="{{elementIds.dd_paging_search_type}}"
  [ngClass]="isFooter ? 'footer_dropdown_on' : 'footer_dropdown_off'" [(ngModel)]="paging.searchType"
  [noAutoComplete]="true" [items]="paging.searchTypes" [optionValueField]="'key'" [optionTextField]="'value'"
  *ngIf="paging.searchTypes && paging.searchTypes.length > 0 && iShowDropDownIndex == 1"
  (close)="onShowHideDropDown(1,true)" (select)="onSelect()">
  <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
    <div id="{{elementIds.dd_paging_search_type}}_{{option.data.key}}">
      <span [ngClass]="paging.searchType == option.data.key ? 'selected_dd_item' : ''">
        {{option.data.value}}
      </span>
    </div>
  </ng-template>
</ngx-select>
<button class="button_icon button_icon_color" style="top:5px"
  *ngIf="isShowFilterOption && paging.searchTypes && paging.searchTypes.length > 0"
  id="{{elementIds.btn_paging_search_type}}" (click)="onShowHideDropDown(1)">filter_alt</button>
<button class="button_icon button_icon_color" style="top:5px" *ngIf="isShowShoppingCart" title="{{countToShow}}"
  [disabled]="countToShow <= 0" (click)="onAction(1)">shop</button>
<span *ngIf="countToShow > 0" class="en">&nbsp;({{countToShow}})</span>
<input autocomplete="off" type="text" [(ngModel)]="paging.searchKey"
  title="{{localService.languageContent.paging.search_key}}" style="max-width: 200px;"
  placeholder="{{localService.languageContent.paging.search_key}}"
  [ngStyle]="{'width': isShowFilterOption || isShowShoppingCart ? (isShowShoppingCart ? 'calc(-150px + 80vw)' : 'calc(100% - 80px)') : 'calc(100% - 40px)'}"
  (keydown.enter)="onSearch()" (input)="onInput()" />
<button class="button_icon button_icon_color " style="float:right;top:5px" *ngIf="isShowSearchButton"
  (click)="onSearch()">search</button>